import type { RumInitConfiguration } from '@datadog/browser-rum';

import { currentAppEnvironment, getDatadogEnv } from '@savgroup-front-common/constants';

export type DatadogRumBaseConfig = Omit<
  RumInitConfiguration,
  'service' | 'sessionReplaySampleRate' | 'allowedTracingUrls'
>;

export const getDatadogRumBaseConfig = (): DatadogRumBaseConfig => ({
  applicationId: 'e1b7b2b6-0b4a-4cb7-b5d3-fda3dcf1badd',
  clientToken: import.meta.env.VITE_DATA_DOG_PUBLIC_KEY,
  site: 'datadoghq.eu',
  proxy: 'https://datadog-proxy.revers.io',
  env: getDatadogEnv(currentAppEnvironment),
  version: `${import.meta.env.VITE_BUILD_NUMBER}`,
  sessionSampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  propagateTraceBaggage: false,
});
